import { UserDto } from '@act/shared/data-transfer-objects';
import { Button } from '@act/storybook';
import Typography from '@mui/material/Typography';
import { HtmlDisplayerWithHyperlinks } from 'react-components/components/HtmlDisplayerWithHyperlinks';
import useInteractionsDialog from 'react-components/dialog-forms/hooks/use-interactions-dialog';
import { selectActingUser } from 'redux/slices/actingUserSlice';
import { membersAppSelectors } from 'redux/slices/memberSlice';
import { notesAppSelectors } from 'redux/slices/notesSlice';
import { userAppSelectors } from 'redux/slices/usersSlice';
import { useAppSelector } from 'redux/store-hooks';
import InfoCard from 'toolkit/info-card/info-card';
import { SmartContentDisplay } from '@act/storybook';

const FeedNoteCard = (props: { noteId: number; shouldHighlight?: boolean }) => {
  const { editNote } = useInteractionsDialog();

  const actingUser: UserDto = useAppSelector(selectActingUser);
  const note = notesAppSelectors.useSelectNoteById(props.noteId);
  const member = membersAppSelectors.useSelectMemberById(note?.userId);
  const isResourcing: boolean = !!note?.resourceInteraction;
  const author = userAppSelectors.useSelectUserById(note?.createdBy);

  // If note doesn't exist (e.g., after deletion), don't render the component
  if (!note) {
    return null;
  }

  if (!actingUser) return;

  const isAuthor = actingUser.id === author?.id;

  const editButton = (
    <Button
      variant="text"
      onClick={event => {
        event.stopPropagation();
        editNote({
          note: note,
          user: member,
        });
      }}
    >
      Edit
    </Button>
  );

  let noteExplanation = `Created by ${
    isAuthor ? 'you' : author?.name || 'Unknown'
  }`;
  if (isResourcing) {
    noteExplanation += ` about ${note.resourceInteraction.resource.title}`;
  }

  return (
    <InfoCard
      subject={isResourcing ? 'Resourcing note' : 'Note'}
      variant={isResourcing ? 'resource' : 'note'}
      startTime={note.createdAt}
      primaryOption={editButton}
      shouldHighlight={props.shouldHighlight}
    >
      <>
        <Typography variant="labelLarge" component="p">
          {noteExplanation}
        </Typography>
        {note.text && (
          <SmartContentDisplay>
            <HtmlDisplayerWithHyperlinks
              note={note.text}
              displayMessage="Links in this note:"
            />
          </SmartContentDisplay>
        )}
      </>
    </InfoCard>
  );
};

export default FeedNoteCard;
